<template>
  <div class="yxtbiz-o2o-enroll-projectset-audit">
    <div>
      <div class="standard-size-16 color-gray-10 font-bolder">{{$t('pc_biz_enroll_lbl_projectset' /** 报名项目集 */)}}</div>
      <yxtf-row type="flex" class="pv24 font-normal font-size-14 border-1px-bottom">
          <yxtf-col :span="24" class="nowrap mh2 felx-center">
            <span class="color-gray-7">{{$t('pc_biz_lbl_projectset_name'/* 项目集名称 */)}}{{$t('pc_biz_enroll_lbl_colon' /* ： */)}}</span>
            <yxtf-tooltip open-filter
                          content="dasd"
                          placement="top">
              <div class="yxtbiz-o2o-enroll-audit_ellipsis">{{info.name}}</div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
      <div class="mv24 standard-size-16 color-gray-10 font-bolder">{{$t('pc_biz_enroll_lbl_subproject_list' /** 子项目列表 */)}}</div>
        <div>
           <!-- 分组 -->
          <div div v-for="item in getMax3List" :key="item.id" :class="item.projectIntegrateType === 1 ? 'set-group': 'sub-content mb12'">
            <Subproject-group v-if="item.projectIntegrateType === 1" class="mb12" :title="item.name" :num="item.project4IntegrateInfo.length">
              <Subproject-item v-for="sItem in item.project4IntegrateInfo"
                              :key="sItem.id"
                              :data="sItem"
              />
            </Subproject-group>
            <Subproject-item v-else :data="item" />
          </div>
        </div>
        <Subproject-more v-if="data.length > 3" :data="more3Data" />
    </div>
  </div>
</template>

<script>
import SubprojectGroup from './components/subproject-group.vue';
import SubprojectItem from './components/subproject-item.vue';
import SubprojectMore from './components/subproject-more.vue';
import { getEnrollProjectChildList } from './service';

export default {
  name: 'YxtbizO2oEnrollProjectsetAudit',
  name_zh: '培训项目集报名审核',
  props: {
    id: {
      type: String,
      default: '',
      desc: '审核中心给的人员记录id',
      setter: 'StringSetter'
    }
  },
  components: {
    SubprojectMore,
    SubprojectGroup,
    SubprojectItem
  },
  data() {
    return {
      data: [],
      more3Data: [],
      info: {}
    };
  },
  computed: {
    getMax3List() {
      return this.data.slice(0, 3);
    }
  },
  watch: {
    id: {
      handler(v) {
        if (v) {
          this.getEnrollProjectChildList(v);
        }
      },
      immediate: true
    }
  },
  methods: {
    getEnrollProjectChildList(id) {
      getEnrollProjectChildList(id).then((data = {}) => {
        if (data.projectIntegrateResp && data.projectIntegrateResp.length > 3) {
          this.more3Data = data.projectIntegrateResp.slice(3);
        }
        this.data = data.projectIntegrateResp || [];
        this.info = data.projectIntegrateSimple || {};
        this.info.description = this.info.description || '--';
      });
    }
  }
};
</script>
